export const languagePolicies = ['arb', 'cmn', 'deu', 'ell', 'heb', 'jpn', 'kor', 'rus', 'tha', 'tur', 'vie']
